(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fh-cages"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('fh-lane-planner')) {
  customElements.define('fh-lane-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('.fh-lane-controls').hidden = false;
      this.group = this.querySelector('[data-group-size]');
      this.status = this.querySelector('[data-planner-status]');
      this.hint = this.querySelector('[data-group-hint]');
      this.priceStatus = this.querySelector('[data-price-status]');
      this.durations = Array.from(this.querySelectorAll('[data-session-duration]'));
      this.cards = Array.from(this.querySelectorAll('[data-lanes]')).sort((a, b) => Number(a.dataset.lanes) - Number(b.dataset.lanes));
      this.update = () => {
        const people = Number(this.group.value);
        const duration = this.durations.find(input => input.checked)?.value || '60';
        const fits = card => Number(card.dataset.maximumPeople) === 0 || people <= Number(card.dataset.maximumPeople);
        const works = people ? this.cards.find(fits) : null;
        const matching = people ? this.cards.filter(card => {
          const range = (card.dataset.recommendedPeople.match(/\d+/g) || []).map(Number);
          const minimum = range[0];
          const maximum = card.dataset.recommendedPeople.includes('+') ? Infinity : (range[1] ?? minimum);
          return people >= minimum && people <= maximum && fits(card);
        }) : [];
        const recommended = matching.at(-1) || works;
        this.cards.forEach(card => {
          const preferred = card === recommended;
          const alternative = card === works && !preferred;
          card.classList.toggle('is-recommended', preferred);
          card.classList.toggle('is-alternative', alternative);
          const badge = card.querySelector('.fh-lane-recommendation');
          badge.hidden = !preferred && !alternative;
          badge.textContent = preferred ? this.status.dataset.recommended : this.status.dataset.works;
          card.querySelectorAll('[data-rate]').forEach(rate => { rate.hidden = rate.dataset.rate !== duration; });
        });
        this.priceStatus.textContent = this.priceStatus.dataset.template.replace('{duration}', duration);
        this.hint.hidden = Boolean(people);
        this.status.hidden = !people;
        if (!people) { this.status.textContent = ''; return; }
        const template = people > 20 ? this.status.dataset.large : works === recommended ? this.status.dataset.single : this.status.dataset.options;
        this.status.textContent = template.replace('{works}', works?.dataset.laneLabel || '').replace('{recommended}', recommended?.dataset.laneLabel || '');
      };
      this.group.addEventListener('change', this.update);
      this.durations.forEach(input => input.addEventListener('change', this.update));
      this.update();
    }
  });
}
if (!customElements.get('fh-group-enquiry')) {
  customElements.define('fh-group-enquiry', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('.fh-occasion-field').hidden = false;
      const choice = this.querySelector('select');
      const link = this.querySelector('a');
      const update = () => {
        const subject = this.dataset.subject + ' — ' + choice.value;
        const body = this.dataset.template.replace('{occasion}', choice.value.toLowerCase());
        link.href = 'mailto:info@thefieldhouse.co.nz?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      };
      choice.addEventListener('change', update);
      update();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-cart-quote"]) return;
  try {
    
function setupFieldhouseQuote() {
  const form = document.getElementById('FieldhouseQuote');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const detail = document.getElementById('FieldhouseQuoteDetails');
  if (form.querySelector('.fh-quote-success, .errors')) detail.open = true;
  const delivery = form.querySelector('[data-fh-delivery]');
  const address = form.querySelector('[data-fh-address]');
  const addressLabel = form.querySelector('[data-fh-address-label]');
  const updateDelivery = () => { address.required = delivery.value === 'Delivery'; addressLabel.hidden = !address.required; };
  delivery.addEventListener('change', updateDelivery);
  updateDelivery();
  const strings = JSON.parse(form.querySelector('[data-fh-quote-strings]').textContent);
  const button = form.querySelector('[data-fh-quote-submit]');
  const status = form.querySelector('[data-fh-quote-status]');
  let prepared = false;
  form.addEventListener('submit', async event => {
    if (prepared) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    button.disabled = true;
    status.textContent = strings.sending;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}, cache:'no-store'});
      if (!response.ok) throw new Error(strings.error);
      const cart = await response.json();
      if (!cart.item_count) throw new Error(strings.empty);
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {style:'currency', currency:cart.currency}).format(cents / 100);
      const lines = cart.items.map(item => {
        const options = (item.options_with_values || []).filter(option => option.value !== 'Default Title').map(option => option.name + ': ' + option.value).join(', ');
        const properties = Object.entries(item.properties || {}).filter(([key]) => !key.startsWith('_')).map(([key,value]) => key + ': ' + value).join('; ');
        return item.quantity + ' × ' + item.product_title + (options ? ' — ' + options : '') + '\nSKU: ' + (item.sku || '—') + ' | Variant: ' + item.variant_id + ' | ' + money(item.final_line_price) + (properties ? '\n' + properties : '') + '\n' + new URL(item.url, location.origin).href;
      });
      form.querySelector('[data-fh-quote-body]').value = strings.subject + '\n\n' + lines.join('\n\n') + '\n\n' + strings.subtotal + ': ' + money(cart.total_price) + ' ' + cart.currency + (cart.note ? '\nCart note: ' + cart.note : '');
      prepared = true;
      button.disabled = false;
      status.textContent = '';
      form.requestSubmit(button);
    } catch (error) {
      prepared = false;
      button.disabled = false;
      status.textContent = error.message || strings.error;
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
    if (typeof event.cartData?.item_count === 'number') {
      document.querySelector('[data-fh-quote-wrapper]').hidden = event.cartData.item_count === 0;
      const emptyPrompt = document.querySelector('[data-fh-quote-empty]');
      if (emptyPrompt) emptyPrompt.hidden = event.cartData.item_count > 0;
      const actions = document.querySelector('[data-fh-quote-actions]');
      if (actions) actions.hidden = event.cartData.item_count === 0;
    }
  });
}
setupFieldhouseQuote();
document.addEventListener('shopify:section:load', setupFieldhouseQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-equipment"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fh-category-browser')) {
  customElements.define('fh-category-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const filters = this.querySelector('.fh-category-filters');
      const cards = [...this.querySelectorAll('[data-category-group]')];
      const status = this.querySelector('[data-category-status]');
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-category-filter]');
        if (!button) return;
        const group = button.dataset.categoryFilter;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => { card.hidden = group !== 'all' && card.dataset.categoryGroup !== group; });
        status.textContent = status.dataset.statusTemplate.replace('{count}', cards.filter(card => !card.hidden).length);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.fh-category-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.fh-header-search-shell[open]').forEach(search => { search.close?.(); search.querySelector('input[type=search]')?.focus(); });
  document.querySelectorAll('.fh-category-menu[open]').forEach(menu => {
    if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    menu.open = false;
  });
});

if (!customElements.get('fh-equipment-navigation')) {
  customElements.define('fh-equipment-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.disclosure = this.querySelector('.fh-equipment-disclosure');
      this.media = window.matchMedia('(min-width:750px)');
      this.sync = () => { this.disclosure.open = this.media.matches; };
      this.sync();
      this.media.addEventListener('change', this.sync);
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.sync); this.initialized = false; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-team-quote"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
  const status = document.querySelector('[data-fh-quote-count]');
  if (!status || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
    const count = event.cartData?.item_count;
    if (typeof count !== 'number') return;
    status.textContent = count ? status.dataset.template.replace('{count}', count) : status.dataset.empty;
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-uniforms"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('fh-uniform-gallery')) {
  customElements.define('fh-uniform-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('.fh-look-controls').hidden = false;
      this.querySelectorAll('[data-look-button]').forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-look-button]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-look]').forEach(panel => { panel.hidden = panel.dataset.look !== button.dataset.lookButton; });
      }));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
